import * as React from 'react';

const POPPER_SELECTOR = '.MuiPickersPopper-root';
const INPUT_EVENTS = ['wheel', 'touchmove', 'keydown', 'pointerdown'];
const SCROLL_KEYS = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '];
// a smooth wheel scroll keeps firing scroll events for a moment after the last wheel event
const USER_SCROLL_WINDOW_MS = 500;

function createPageScrollHold() {
  let pinnedScrollY: number | null = null
  let closing = false
  let userScrolledAt = 0

  function holdScroll() {
    if (pinnedScrollY === null) { return }
    if (Date.now() - userScrolledAt < USER_SCROLL_WINDOW_MS) {
      pinnedScrollY = window.scrollY
      return
    }
    if (window.scrollY !== pinnedScrollY) { window.scrollTo(0, pinnedScrollY) }
  }

  function release() {
    pinnedScrollY = null
    closing = false
    INPUT_EVENTS.forEach(type => window.removeEventListener(type, noteInput, { capture: true }))
    window.removeEventListener('scroll', holdScroll)
  }

  function noteInput(event: Event) {
    const target = event.target instanceof Element ? event.target : null
    if (target?.closest(POPPER_SELECTOR)) { return }
    if (closing) {
      release()
      return
    }
    if (event.type === 'pointerdown' && target !== document.documentElement) { return }
    if (event instanceof KeyboardEvent && !SCROLL_KEYS.includes(event.key)) { return }
    userScrolledAt = Date.now()
  }

  function hold() {
    closing = false
    pinnedScrollY = window.scrollY
    INPUT_EVENTS.forEach(type => window.addEventListener(type, noteInput, { capture: true, passive: true }))
    window.addEventListener('scroll', holdScroll)
  }

  function releaseOnNextInput() {
    if (pinnedScrollY !== null) { closing = true }
  }

  return { hold, release, releaseOnNextInput }
}

// MUI focuses a portaled picker's time columns without preventScroll, jumping the page behind it,
// once more as it closes too. Undo those jumps from open until the teacher's next action after close;
// the teacher's own scrolling always goes through.
export default function usePageScrollHeldWhileOpen() {
  const [scrollHold] = React.useState(createPageScrollHold)

  React.useEffect(() => scrollHold.release, [scrollHold])

  return scrollHold
}
